/*eslint-disable no-template-curly-in-string*/

import { printValue, type LocaleObject } from "yup";

// Based on https://github.com/jquense/yup/blob/b940eef48eb7456622ae384d0ffa7363d4fbad25/src/locale.ts
export const mixed: LocaleObject["mixed"] = {
	default: "${path} є недійсним",
	required: "${path} є обов’язковим полем",
	defined: "${path} має бути визначено",
	notNull: "${path} не може бути null",
	oneOf: "${path} має бути одним із таких значень: ${values}",
	notType: ({ path, type, value, originalValue }) => {
		const isCast = originalValue != null && originalValue !== value;
		let msg =
			`${path} має бути типу \`${type}\`, ` +
			`але кінцевим значенням було: \`${printValue(value, true)}\`` +
			(isCast
				? ` (перетворене зі значення \`${printValue(
						originalValue,
						true
				  )}\`).`
				: ".");

		if (value === null) {
			msg +=
				`\n Якщо "null" використовується як пусте значення, переконайтеся, що схема позначена як` +
				" `.nullable()`";
		}

		return msg;
	},
};

export const string: LocaleObject["string"] = {
	length: "${path} має містити рівно ${length} символів",
	min: "${path} має містити щонайменше ${min} символів",
	max: "${path} має містити не більше ніж ${max} символів",
	matches: '${path} має відповідати наступному шаблону: "${regex}"',
	email: "${path} має бути коректною електронною адресою",
	url: "${path} має бути коректною URL-адресою",
	uuid: "${path} має бути коректним UUID",
	trim: "${path} має бути без зайвих пробілів",
	lowercase: "${path} має бути рядком у нижньому регістрі",
	uppercase: "${path} має бути рядком у верхньому регістрі",
};

export const number: LocaleObject["number"] = {
	min: "${path} має бути більшим або рівним ${min}",
	max: "${path} має бути меншим або рівним ${max}",
	lessThan: "${path} має бути меншим за ${less}",
	moreThan: "${path} має бути більшим за ${more}",
	positive: "${path} має бути додатнім числом",
	negative: "${path} має бути від’ємним числом",
	integer: "${path} має бути цілим числом",
};

export const date: LocaleObject["date"] = {
	min: "${path} має бути пізніше ніж ${min}",
	max: "${path} має бути раніше ніж ${max}",
};

export const boolean: LocaleObject["boolean"] = {
	isValue: "${path} має бути значенням ${value}",
};

export const object: LocaleObject["object"] = {
	noUnknown: "${path} містить невизначені ключі: ${unknown}",
};

export const array: LocaleObject["array"] = {
	min: "${path} має містити щонайменше ${min} елементів",
	max: "${path} має містити не більше ніж ${max} елементів",
	length: "${path} має містити рівно ${length} елементів",
};
